import { cx } from '@libs/classnames';
import { DefaultAvatarIcon } from '@ui/icons/DefaultAvatarIcon/DefaultAvatarIcon';

import styles from './Avatar.module.css';

export type AvatarSize = '72' | '36' | '32' | '28' | '108' | '200';

export type Props = {
  className?: string;
  onClick?: () => void;
  size?: AvatarSize;
  imageSrc?: string;
  text: string;
};
export function Avatar({ className, onClick, imageSrc, text, size = '36' }: Props) {
  return (
    <div
      onClick={onClick}
      className={cx(
        styles.root,
        { [styles.clickable]: !!onClick },
        styles[('size-' + size) as 'size-36'],
        className,
      )}
    >
      <div className={styles.contentWrapper}>
        {imageSrc && <img className={styles.image} src={imageSrc} alt="Avatar" />}

        {!imageSrc && text && <span className={styles.text}>{text}</span>}

        {!imageSrc && !text && <DefaultAvatarIcon className={styles.image} />}
      </div>
    </div>
  );
}
